import clsx from "clsx";
import styles from "./STProgressBar.module.css";

export const STProgressBar = ({ value = 0 }) => {
  const progress = Math.min(100, Math.max(0, value));

  return (
    <div
      className={clsx(
        styles.progress,
        "position-relative w-100 d-flex align-items-center",
      )}
    >
      <div
        className={clsx(
          styles.track,
          "bg-dreamy-cloud radius-xl overflow-hidden w-100",
        )}
      >
        <div
          className={clsx(
            styles.fill,
            "h-100 bg-blue radius-xl  transition-smooth",
          )}
          style={{ width: `${progress}%` }}
        />
      </div>

      {/* LABEL OUTSIDE TRACK (IMPORTANT) */}
      <span
        className={clsx(
          styles.label,
          "h6 big mb-0 fw-medium bg-blue text-white position-absolute radius-xl d-flex justify-content-cetner align-items-center",
        )}
        style={{ left: `calc(${progress}% - 16px)` }}
      >
        {progress}%
      </span>
    </div>
  );
};
